import React from "react";
import styles from '../../screens/ForthScreen.module.css';
import ShortsRec from "../../components/shortsRec/Shorts";
import Button from "../../components/button/Button";

const RecommendationsSection = () => {
  return <>
    <div className={styles.title}>
      ועכשיו בואי תשמעי קצת מאנשים
      <div className={styles.titleHighlight}>שהחליטו לעשות שינוי</div>
    </div>
    <ShortsRec />
    <Button text="נטלי, בואי נדבר!" />
  </>
};

export default RecommendationsSection;
